import type { PortalSession } from '@/types/api'
import { request } from '@/utils/request'

export interface WechatAuthorizeUrlParams {
  authorizationMode?: 'basic' | 'complete'
  redirectUri: string
  state: string
}

export interface WechatAuthorizeUrlResp {
  authorizeUrl: string
}

export const getWechatAuthorizeUrl = (params: WechatAuthorizeUrlParams) =>
  request<WechatAuthorizeUrlResp>({
    method: 'GET',
    params,
    skipPortalAuth: true,
    url: '/member-portal/auth/wechat/authorize-url',
  })

export const exchangeWechatCode = (code: string, state: string) =>
  request<PortalSession>({
    data: { code, state },
    method: 'POST',
    skipPortalAuth: true,
    url: '/member-portal/auth/wechat/exchange',
  })

export const refreshPortalSession = () =>
  request<PortalSession>({
    method: 'POST',
    url: '/member-portal/auth/wechat/session/refresh',
  })

export const logoutPortalSession = () =>
  request<void>({
    method: 'POST',
    url: '/member-portal/auth/wechat/session/logout',
  })
